import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "recordingInput", "dayInput", "hourInput" ];
  static values = { indexUrl: String }

  connect() {
    // Optional: Initialize the array on load
    this.updateRecordingArray();
  }

  // Call this whenever a recording is selected for a segment
  updateRecordingArray() {
    const ids = this.recordingInputTargets.map(input => input.value.trim());

    // Update the hidden input that your Rails form will actually submit
    if (this.hasHiddenArrayInputTarget) {
      this.hiddenArrayInputTarget.value = JSON.stringify(ids);
    }

    console.log("Current Recording IDs:", ids);
  }

  // Example action called when a recording is picked
  selectRecording(event) {
    const segmentElement = event.currentTarget.closest(".segment-item");

    // Logic to open a modal/search and get an ID...
    const chosenId = "REC-12345";

    segmentElement.dataset.recordingId = chosenId;
    segmentElement.querySelector(".selected-recording-display").innerText = chosenId;

    this.updateRecordingArray();
  }

  async submitSchedule(event) {
    event.preventDefault() // Stop the standard form submit

    // 1. Sync the values from the rest of the page into our hidden fields
    this.syncGlobalValues();

    const form = event.currentTarget;
    const submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    const url = event.currentTarget.action
    const formData = new FormData(event.currentTarget)

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: { "Accept": "application/json" }
      })

      const data = await response.json();

      if (response.ok) {
        // Success! Show a message, maybe clear the inputs or disable them
        window.location.href = this.indexUrlValue;
      } else {
        // This is where we catch the :unprocessable_entity (422)
        // The error message comes from our Rails 'render json: { error: ... }'
        this.handleError(data.error);
      }
    } catch (error) {
      this.handleError("Network error or server is down.");
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  }

  syncGlobalValues() {
    // Reach into the hour selector dropdown
    const hourSelector = document.getElementById("hour");
    if (hourSelector) {
      this.hourInputTarget.value = hourSelector.value;
    }

    // Reach into the calendar controller's state
    // We can find the current date from the wrapper's data attribute
    const calendarWrapper = document.querySelector('[data-program-schedule-calendar-current-date-value]');
    if (calendarWrapper) {
      this.dayInputTarget.value = calendarWrapper.dataset.programScheduleCalendarCurrentDateValue;
    }
  }

  handleError(message) {
    // You can point this to a specific div on your page
    console.error("Scheduling Error:", message);

    const container = document.getElementById("flash-container");

    if (container) {
      container.innerHTML = "";

      const alertDiv = document.createElement("div");

      alertDiv.className = "alert alert-danger flash_notice";
      alertDiv.innerText = message;

      container.appendChild(alertDiv);

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      alert(message); // Simple for the deadline, but you could update a <div>
    }
  }

}
